import { Link } from 'react-router-dom';
import { goldTypes } from '@/mocks/goldPrices';

export default function Hero() {
  const sjc = goldTypes[0];

  return (
    <section className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20luxury%20golden%20metallic%20flowing%20waves%20on%20a%20deep%20black%20background%2C%20elegant%20premium%20financial%20investment%20concept%2C%20warm%20gold%20light%20reflections%2C%20dark%20sophisticated%20atmosphere%2C%20high%20detail%20cinematic%20lighting%2C%20minimal%20composition&width=1600&height=900&seq=hero-gold-abstract-1&orientation=landscape"
          alt="Nền vàng kim loại cao cấp Goldsbvvn"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/55 to-background-50"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 md:px-6 pt-28 md:pt-40 pb-16 md:pb-24 text-center">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/30 text-primary-300 text-xs font-semibold">
          <i className="ri-flashlight-line text-sm"></i>
          Giá vàng cập nhật liên tục 24/7
        </span>

        <h1 className="mt-6 text-3xl md:text-5xl font-bold leading-tight text-foreground-950">
          Nền tảng <span className="text-gold-gradient">giao dịch vàng</span> hàng đầu
          <br className="hidden md:block" /> dành cho nhà đầu tư Việt
        </h1>

        <p className="mt-5 text-base md:text-lg text-foreground-600 max-w-2xl mx-auto leading-relaxed">
          Theo dõi giá vàng SJC, PNJ, DOJI theo thời gian thực. Giao dịch mua bán minh bạch, nạp rút tiền nhanh chóng và an toàn.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/giao-dich"
            className="w-full sm:w-auto px-7 py-3 rounded-md bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors gold-glow"
          >
            Bắt đầu giao dịch
          </Link>
          <Link
            to="/thi-truong"
            className="w-full sm:w-auto px-7 py-3 rounded-md border border-background-400 text-foreground-800 font-semibold text-sm hover:border-primary-500 hover:text-primary-300 whitespace-nowrap cursor-pointer transition-colors"
          >
            Xem bảng giá
          </Link>
        </div>

        <div className="mt-10 inline-flex flex-wrap items-center justify-center gap-x-6 gap-y-3 px-5 py-4 rounded-xl bg-background-100/80 border border-background-200/60 backdrop-blur">
          <div className="text-left">
            <p className="text-xs text-foreground-600">Vàng SJC (mua)</p>
            <p className="text-lg font-bold text-foreground-950 whitespace-nowrap">{sjc.buy.toLocaleString('vi-VN')}đ</p>
          </div>
          <div className="w-px h-10 bg-background-300/60 hidden sm:block"></div>
          <div className="text-left">
            <p className="text-xs text-foreground-600">Vàng SJC (bán)</p>
            <p className="text-lg font-bold text-foreground-950 whitespace-nowrap">{sjc.sell.toLocaleString('vi-VN')}đ</p>
          </div>
          <div className="w-px h-10 bg-background-300/60 hidden sm:block"></div>
          <div className="text-left">
            <p className="text-xs text-foreground-600">Thay đổi hôm nay</p>
            <p className="text-lg font-bold text-emerald-500 whitespace-nowrap">+{sjc.changePercent.toFixed(2)}%</p>
          </div>
        </div>
      </div>
    </section>
  );
}